import { render } from "./AppFooter.vue?vue&type=template&id=8bb7f774&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=8bb7f774&scoped=true&lang=css"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb7f774"]])

export default __exports__